import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { PieChartComponent } from "../../../../components/chart/pie-chart/pie-chart.component";

interface StatItem {
  label: string;
  value: number;
  icon: string;
  iconBg: string;
}

@Component({
  selector: "app-test-case-summary",
  standalone: true,
  imports: [PieChartComponent, CommonModule],
  templateUrl: "./test-case-summary.component.html",
  styleUrl: "./test-case-summary.component.scss",
})
export class TestCaseSummaryComponent implements OnInit {
  @Input() data: any = {};

  @Input() metricDisplayName: string = '';

  readonly bgColors: string[] = ['#02F576', '#FC404A'];
  readonly pieChartMeta: any = { isLegendVisible: false, cutout: '60%' };

  chartData: any;
  centerText = '';
  statRow1: StatItem[] = [];
  statRow2: StatItem[] = [];
  percentage: { label: string; value: number; color: string; percentage: number }[] = [];

  ngOnInit(): void {
    this.buildStats();
    this.buildChart();
  }

  private buildStats(): void {
    this.statRow1 = [
      {
        label: 'Planned',
        value: this.data?.planned ?? 0,
        icon: 'assets/images/virtusa-icons/planning-target-outline.svg',
        iconBg: 'rgba(94, 29, 228, 0.08)',
      },
      {
        label: 'Actual',
        value: this.data?.actual ?? 0,
        icon: 'assets/images/virtusa-icons/arrows-cycle-outline.svg',
        iconBg: 'rgba(252, 64, 74, 0.08)',
      },
      {
        label: 'Skipped',
        value: this.data?.skipped ?? 0,
        icon: 'assets/images/virtusa-icons/compliance-disaster-recovery-outline.svg',
        iconBg: 'rgba(208, 210, 212, 0.5)',
      },
    ];
    this.statRow2 = [
      {
        label: 'Passed',
        value: this.data?.passed ?? 0,
        icon: 'assets/images/virtusa-icons/passed_Icon.svg',
        iconBg: 'rgba(2, 245, 118, 0.15)',
      },
      {
        label: 'Failed',
        value: this.data?.failed ?? 0,
        icon: 'assets/images/virtusa-icons/failed_Icon.svg',
        iconBg: 'rgba(252, 64, 74, 0.08)',
      },
    ];
  }

  private buildChart(): void {
    const passed  = this.data?.passed  ?? 0;
    const failed  = this.data?.failed  ?? 0;
    const actual  = this.data?.actual  ?? 0;
    const total   = passed + failed;

    this.centerText = `${passed}/${actual}`;
    // Pass only passed + failed so the doughnut shows 2 segments
    this.chartData  = { passed, failed };

    this.percentage = [
      {
        label: 'Passed',
        value: passed,
        color: this.bgColors[0],
        percentage: total > 0 ? Math.round((passed / total) * 100) : 0,
      },
      {
        label: 'Failed',
        value: failed,
        color: this.bgColors[1],
        percentage: total > 0 ? Math.round((failed / total) * 100) : 0,
      },
    ];
  }
}
